import { removeWorkSpaceFromLS } from 'helpers/functions/workspaceHelpers';
import React, { useEffect, useRef } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Navbar from '../NavBar/Navbar';
import SideBar from '../SideBar/SideBar';
import { sendPageViewGA } from 'helpers/functions/GoogleAnalytics/GA';
import { useAppSelector } from 'hooks/redux';
import { selectActiveUser } from 'store/userState/selectors';


const Layout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutId = useRef<unknown>(null)
  const activeUserStore = useAppSelector(selectActiveUser)

  const INACTIVITY_TIMEOUT = 21600000 // 6 hours

  const handleUserActivity = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if(timeoutId.current) clearTimeout(timeoutId.current)
    timeoutId.current = setTimeout(()=>{
      localStorage.removeItem('user');
      localStorage.removeItem('mfaVerified');
      removeWorkSpaceFromLS()
      navigate('/signin')
      window.location.reload()
    }, INACTIVITY_TIMEOUT)
  }

  useEffect(()=>{
    window.addEventListener('mousemove', handleUserActivity)
    window.addEventListener('mouseup', handleUserActivity)
    return () => {
      window.removeEventListener('mousemove', handleUserActivity)
      window.removeEventListener('mouseup', handleUserActivity)
    }
  }, [])

  useEffect(()=>{
    // Only send page view if user ID is available
    if (activeUserStore.id) {
      sendPageViewGA(activeUserStore.id)
    }
  }, [location.pathname, activeUserStore.id])

  return (
    <div className='page-content'>
      <Navbar />
      <SideBar />
      <main className='main-content'>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
};

export default Layout;